import { Link } from "react-router-dom";
import { Tag, ArrowRight, ShieldCheck, Sparkles, Gift, Wrench } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { DiagonalLines, DotGrid, FloatingShape } from "@/components/Deco";

const TILES = [
  {
    icon: ShieldCheck,
    title: "Bizalmi ajánlat",
    text: "Ingyenes teherautó-ponyva állapotfelmérés, kötelezettség nélkül.",
    to: "/akciok#bizalmi-ajanlat",
  },
  {
    icon: Sparkles,
    title: "Költségcsökkentő ajánlat",
    text: "Beszámítjuk régi, jó állapotú ponyváját az új termék árába.",
    to: "/akciok#koltsegcsokkento",
  },
  {
    icon: Gift,
    title: "10+1 használt ponyva",
    text: "10 db használt kamionponyva vásárlása esetén egyet ajándékba adunk.",
    to: "/akciok#bonusz-ajanlat",
  },
  {
    icon: Wrench,
    title: "Medenceponyva csomag",
    text: "Bélés + takaró ponyva csomagáron – standard méretekhez.",
    to: "/akciok#szett-ajanlat",
  },
];

export const PromoBanner = () => {
  return (
    <section
      id="akciok-banner"
      data-testid="promo-banner"
      className="bg-[#0B192C] text-white relative overflow-hidden"
    >
      <FloatingShape className="-top-20 -right-20 w-96 h-96" color="#EA580C" />
      <FloatingShape className="-bottom-24 -left-20 w-96 h-96" color="#1E3E62" />
      <DiagonalLines className="absolute inset-0 text-white" opacity={0.04} />
      <DotGrid
        className="absolute top-1/2 right-12 w-72 h-32 opacity-30"
        color="rgba(234,88,12,0.55)"
      />

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 grid md:grid-cols-12 gap-10 items-center relative">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="md:col-span-5"
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#EA580C]/15 border border-[#EA580C]/30 text-[#EA580C] text-xs font-semibold tracking-widest uppercase glow-pulse">
            <Tag className="w-3.5 h-3.5" />
            Aktuális akcióink
          </div>
          <h2 className="mt-4 font-heading font-bold text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight">
            Négy aktuális{" "}
            <span className="text-[#EA580C]">ajánlat</span> Önnek.
          </h2>
          <p className="mt-4 text-gray-300 max-w-md leading-relaxed">
            Bizalmi ajánlat ingyenes felméréssel, prémium gyártás
            beszámítással, ajándék használt ponyva és medence csomag.
            Kérje személyre szabott árajánlatát.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Link
              to="/akciok"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-[#EA580C] hover:bg-[#C2410C] text-white font-semibold transition-colors group"
            >
              Összes akció
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/#ajanlat"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border-2 border-white/30 hover:bg-white hover:text-[#0B192C] font-semibold transition-colors"
            >
              Ajánlatkérés
            </Link>
          </div>
        </motion.div>

        <div className="md:col-span-7 grid sm:grid-cols-2 gap-3">
          {TILES.map((t, i) => (
            <motion.div
              key={t.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
            >
              <Link
                to={t.to}
                className="group relative block p-5 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 hover:border-[#EA580C]/40 overflow-hidden transition-all"
              >
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-md bg-[#EA580C] text-white flex items-center justify-center shrink-0">
                    <t.icon className="w-5 h-5" />
                  </div>
                  <div className="font-heading font-bold text-white text-base">
                    {t.title}
                  </div>
                </div>
                <p className="mt-3 text-xs text-gray-400 leading-relaxed">
                  {t.text}
                </p>
                <ArrowRight className="absolute top-5 right-5 w-4 h-4 text-[#EA580C] opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromoBanner;
